export default __webpack_public_path__ + "static/media/icon-download-dark.d276de19.svg";